import React, { Component } from "react";
import PropTypes from "prop-types";
import { Alert, Button, Form, Modal } from "react-bootstrap";

import { get, put } from "../../../utils/DeApi";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import { Fragment } from "react";
import "./CatalogueAssembly.scss";

class CatalogueAssembly extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      inventories: [],
      categories: [],
      category: false,
      inventory: false,
      selections: [],
      catalogue: [],
    };
  }

  componentDidMount() {
    this.fetchInventories();
    this.fetchCategories();
    this.setState({
      selections: this.props.selections || [],
    });
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function (promise) {
      promise.cancel();
    });
  }

  toggleModal() {
    const { selectedDocs } = this.props;
    this.setState({
      category:
        selectedDocs.length === 1 ? this.getCategory(selectedDocs[0]) : false,
      inventory:
        selectedDocs.length === 1 ? this.getInventory(selectedDocs[0]) : false,
      show: !this.state.show,
      catalogue: [],
    });
  }

  selectInventory(ev) {
    const selected = ev.target.value;
    this.setState({
      catalogue: [],
      inventory: selected === "false" ? false : selected,
    });
  }

  fetchInventories() {
    this.setState({ error: null, isLoading: true });

    const fetchInventoriesPromise = get("/inventories");

    fetchInventoriesPromise.promise
      .then((response) => {
        this.setState({
          inventories: response.data,
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });

    this.subscribedPromises.push(fetchInventoriesPromise);
  }

  /* *** fetching catrgories ( below ) *** */
  fetchCategories() {
    this.setState({ isLoading: true });
    const fetchCategoryPromise = get("/categories");
    fetchCategoryPromise.promise
      .then((response) => {
        this.setState({
          categories: response.data,
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
    this.subscribedPromises.push(fetchCategoryPromise);
  }

  /* *** categories dropdown onChange handler ( below ) *** */
  selectCategory(event) {
    const selected = event.target.value;
    this.setState({
      catalogue: [],
      category: selected === "false" ? false : selected,
    });
  }

  assemble() {
    const { filedAt, selectedDocs, onCatalogueAssembled } = this.props;
    this.setState({ error: null, isLoading: true });
    this.bothSubmission(filedAt, selectedDocs, onCatalogueAssembled);
    return;
  }

  /* *** handle inventory submission ( below ) *** */
  inventorySubmission(filedAt, selectedDocs, onCatalogueAssembled) {
    const { inventory } = this.state;
    const inventoryPromise = put(`/catalogues/${filedAt}/inventory`, {
      documents: selectedDocs,
      inventory: inventory,
    });
    inventoryPromise.promise
      .then((response) => {
        this.setState(
          {
            catalogue: response.data,
            error: null,
            isLoading: false,
          },
          () => {
            onCatalogueAssembled();
          }
        );
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });

    this.subscribedPromises.push(inventoryPromise);
  }

  /* *** handle category submission ( below ) *** */
  categorySubmission(filedAt, selectedDocs, onCatalogueAssembled) {
    const { category } = this.state;
    const categoryPromise = put(`/catalogues/${filedAt}/category`, {
      documents: selectedDocs,
      category: category,
    });
    categoryPromise.promise
      .then((response) => {
        this.setState(
          {
            catalogue: response.data,
            error: null,
            isLoading: false,
          },
          () => {
            onCatalogueAssembled();
          }
        );
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });

    this.subscribedPromises.push(categoryPromise);
  }

  /* *** handle category and inventory submission ( both together ) *** */
  bothSubmission(filedAt, selectedDocs, onCatalogueAssembled) {
    let { inventory, category } = this.state;

    inventory =
      selectedDocs.length > 1 && !inventory
        ? false
        : selectedDocs.length === 1 && !inventory
        ? "-1"
        : inventory;
    category =
      selectedDocs.length > 1 && !category
        ? false
        : selectedDocs.length === 1 && !category
        ? "-1"
        : category;

    const bothSubmissionPromise = put(
      `/catalogues/${filedAt}/inventoryAndCategory`,
      {
        documents: selectedDocs,
        inventory: inventory,
        category: category,
      }
    );
    bothSubmissionPromise.promise
      .then((response) => {
        this.updateSelections(response.data);
        this.setState(
          {
            catalogue: response.data,
            error: null,
            isLoading: false,
            show: false,
          },
          () => {
            onCatalogueAssembled();
          }
        );
      })
      .catch((error) => {
        console.log("Error: ", error);
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
    this.subscribedPromises.push(bothSubmissionPromise);
  }

  updateSelections(catalogue) {
    let items = {};
    if (catalogue.length === 1) {
      items = this.state.selections
        .filter((a) => a.id != catalogue[0].id)
        .concat(catalogue[0]);
      this.setState({ selections: [...items] });
    }
  }

  getCategory(selectedDocs) {
    const { selections } = this.state;
    let data = selections
      .filter((data) => data.id === selectedDocs)
      .map((rec) =>
        rec.category && rec.category.length ? rec.category[0].id : false
      );
    return data.length ? data[0] : false;
  }

  getInventory(selectedDocs) {
    const { selections } = this.state;
    let data = selections
      .filter((data) => data.id === selectedDocs)
      .map((rec) =>
        rec.inventory && rec.inventory.length ? rec.inventory[0].id : false
      );
    return data.length ? data[0] : false;
  }

  render() {
    const {
      isLoading,
      error,
      show,
      inventories,
      categories,
      catalogue,
      inventory,
      category,
    } = this.state;

    const { selectedDocs } = this.props;

    return (
      <Fragment>
        <Button
          variant="default"
          className="btn btn-outline-deal-style roundedEdges"
          size="sm"
          disabled={!selectedDocs.length}
          onClick={() => this.toggleModal()}
        >
          Submit {selectedDocs.length} Selected to Catalogue{" "}
          <span className="material-icons">present_to_all</span>
        </Button>

        <Modal
          show={show}
          onHide={() => this.toggleModal()}
          animation={false}
          backdrop={"static"}
          scrollable={"true"}
          className="center"
        >
          <Modal.Header closeButton>
            <Modal.Title as={"div"}>
              <h3>Submit to Catalogue</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Select a catalogue.</Form.Label>
              <Form.Control
                as="select"
                custom
                className="roundedEdges form-control border-thin-gray"
                onChange={this.selectInventory.bind(this)}
                value={inventory}
              >
                <option value={false}>Select a catalogue</option>
                {inventories.map((inventory) => {
                  return (
                    <option key={inventory.id} value={inventory.id}>
                      {inventory.name}
                    </option>
                  );
                })}
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Select a category.</Form.Label>
              <Form.Control
                as="select"
                custom
                className="roundedEdges form-control border-thin-gray"
                onChange={this.selectCategory.bind(this)}
                value={category}
              >
                <option value={false}>Select a category</option>
                {categories.map((cat) => {
                  return (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  );
                })}
              </Form.Control>
            </Form.Group>
            {catalogue.length > 0 && show && (
              <Alert variant="success">
                <h4>Success</h4>
                {catalogue.length} Documents added to{" "}
                {catalogue.length > 0 && inventory && !category
                  ? inventories.find((item) => item.id === inventory).name
                  : !inventory && catalogue.length > 0 && category
                  ? categories.find((item) => item.id === category).name
                  : inventory !== false &&
                    catalogue !== false &&
                    catalogue.length > 0
                  ? inventories.find((item) => item.id === inventory).name +
                    " and " +
                    categories.find((item) => item.id === category).name
                  : null}{" "}
                catalogue.
              </Alert>
            )}
            {isLoading && <Loader />}
            {error && <ErrorHandler error={error} />}
          </Modal.Body>
          <Modal.Footer>
            {/* <Button variant="null" className="btn btn-outline-danger roundedEdges" onClick={() => this.toggleModal()}>
              Close
            </Button> */}
            <Button
              variant="null"
              className="btn-success-deal-style roundedEdges"
              onClick={() => this.assemble()}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

CatalogueAssembly.propTypes = {
  selectedDocs: PropTypes.array.isRequired,
  filedAt: PropTypes.string.isRequired,
};

export default CatalogueAssembly;
